<template>
  <Drop style="min-height: 400px;" >
    <Drag :transferData="{ location: 'backlog' }">
        <div class="dev-priorities-ideas">
          <div class="cards-edit-box">
              <div class="edit-cards-start">
                  <textarea class="board-cart-textarea" placeholder="Card Title"
                            ref="taskName"
                            rows="1"
                            :value="'Source #1'"
                  ></textarea>
              </div>
          </div>
          <div class="cards-edit-box">
              <div class="edit-cards-start">
                  <textarea class="board-cart-textarea" placeholder="Card Title"
                            ref="taskName"
                            rows="1"
                            :value="'Source #2'"
                  ></textarea>
              </div>
          </div>
          <div class="cards-edit-box">
              <div class="edit-cards-start">
                  <textarea class="board-cart-textarea" placeholder="Card Title"
                            ref="taskName"
                            rows="1"
                            :value="'Source #3'"
                  ></textarea>
              </div>
          </div>
          <div class="board-add-card align-center">
              <a >
                  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#6E7077" d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 010-2h10a1 1 0 110 2zm-5 5a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"/>
                  </svg>
                  <span class="ml-2">Add a Card</span>
              </a>
          </div>
      </div>
    </Drag>
  </Drop>
</template>

<script>
import MovingPrioritiesItems from "../../mixins/MovingPrioritiesItems";
import BacklogTask from "./BacklogTask";
import Drop from "./Drop";
import Drag from "./Drag";

export default {
    name: "BackLog",
    props: ['board', 'location', 'location_set'],
    mixins: [MovingPrioritiesItems],
    components: {BacklogTask, Drop, Drag},
    data: () => {
        return {
            enableExtraClick: true,
            renameTitle: false,
        };
    },
    methods: {
        addNewTaskTx () {
            this.$parent.enableExtraClick = false;
            setTimeout(() => {
                this.$refs.taskName.focus()
            })
        },
    }
}
</script>

<style scoped>
.align-center {
    margin: auto;
    width: 100%;
    padding: 10px;
}
.center a {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
textarea {
    height: 52px;
}
</style>
